import { EcommStr } from 'client/widgets/runtime-order-confirmation/useEcommStr';
import { CollectionItem } from './types';

// A customer-chosen price makes `displayed_price` meaningless, so the row's minimum stands in for it.
export function customPricingPriceText(
    data: CollectionItem['data'],
    str: EcommStr
): string | undefined {
    const customPricing = data.custom_pricing;
    if (customPricing?.mode !== 'CUSTOM') return undefined;

    const minimum = customPricing.minimum ?? 0;
    if (minimum > 0) {
        const displayedMinimum = customPricing.displayed_minimum;
        return str('nativeEcommRuntime.custom_pricing.from', {
            0: displayedMinimum?.trim()
                ? displayedMinimum
                : formatBareAmount(minimum, data.currency),
        });
    }
    return str('nativeEcommRuntime.custom_pricing.pay_what_you_want');
}

// The catalog formats every minimum it sends; should one arrive bare, still show the floor, as the gallery does.
function formatBareAmount(amount: number, currency?: string): string {
    const number = Number.isInteger(amount)
        ? String(amount)
        : amount.toFixed(2);
    return currency?.trim() ? `${number} ${currency}` : number;
}
